(() => {
  document.querySelectorAll('[data-anya-product]').forEach((product) => {
    const slides = [...product.querySelectorAll('[data-product-slide]')];
    const thumbs = [...product.querySelectorAll('[data-gallery-thumb]')];
    const counter = product.querySelector('[data-gallery-counter]');
    const selectors = [...product.querySelectorAll('[data-product-option]')];
    const variantInput = product.querySelector('[data-variant-id]');
    const quantityInput = product.querySelector('[data-product-quantity]');
    const cityInput = product.querySelector('[data-product-city]');
    const promoInput = product.querySelector('[data-product-promo]');
    const price = product.querySelector('[data-product-price]');
    const shippingEl = product.querySelector('[data-product-shipping]');
    const totalEl = product.querySelector('[data-product-total]');
    const summaryEl = product.querySelector('[data-product-summary]');
    const beforeRow = product.querySelector('[data-product-before-row]');
    const beforeEl = product.querySelector('[data-product-before]');
    const savingsRow = product.querySelector('[data-product-savings-row]');
    const savingsEl = product.querySelector('[data-product-savings]');
    const giftRow = product.querySelector('[data-product-gift-row]');
    const giftEl = product.querySelector('[data-product-gift]');
    const priceLabel = product.querySelector('[data-product-price-label]');
    const scentDesc = product.querySelector('[data-product-scent-desc]');
    const whatsapp = product.querySelector('[data-product-whatsapp]');
    const stickyWhatsapp = product.querySelector('[data-product-sticky-whatsapp]');
    const stickyOptions = product.querySelector('[data-product-sticky-options]');
    const stickyPrice = product.querySelector('[data-product-sticky-price]');
    const status = product.querySelector('[data-product-status]');
    const packNotice = product.querySelector('[data-product-pack-notice]');
    const packKicker = product.querySelector('[data-pack-kicker]');
    const packTitle = product.querySelector('[data-pack-title]');
    const packCopy = product.querySelector('[data-pack-copy]');
    const composePack = product.querySelector('[data-compose-recommended-pack]');
    const variantsNode = product.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const T = (() => { try { return JSON.parse(product.querySelector('[data-anya-pjs]')?.textContent || '{}'); } catch (e) { return {}; } })();
    const packName = (p) => (T.packs && T.packs[String(p.offerId).replace(/-/g, '_')]) || p.name;
    const W = JSON.parse(document.querySelector('[data-anya-runtime]')?.textContent || '{}');
    const currency = product.dataset.currency || 'DH';
    let shippingRate = null;
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let selectedVariant = variants.find((variant) => String(variant.id) === variantInput?.value) || variants[0];
    let recommendedPack = null;

    const packRules = {
      '50 g': {
        2: { offerId: 'duo', name: 'Duo — meilleure vente', price: 169, saving: 11 },
        3: { offerId: 'trio', name: 'Trio — meilleure offre', price: 229, saving: 41 },
        4: { offerId: 'signature', name: 'Pack signature', price: 299, saving: 61, giftValue: 39, bonus: '1 mini 15 g offert' },
      },
      '15 g': {
        3: { offerId: 'discovery-3', name: 'Découverte — 3 minis', price: 99, saving: 18 },
        6: { offerId: 'discovery-6', name: 'Découverte — 6 minis', price: 179, saving: 55 },
      },
    };

    const money = (cents) => `${Number(cents / 100).toLocaleString('fr-FR')} ${currency}`;
    const getStoredPromo = () => {
      try { return localStorage.getItem('anya_referral_code') || ''; } catch (e) { return ''; }
    };
    const storePromo = (value) => {
      try {
        if (value) localStorage.setItem('anya_referral_code', value);
        else localStorage.removeItem('anya_referral_code');
      } catch (e) {}
    };
    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
        slide.setAttribute('aria-hidden', String(i !== activeIndex));
      });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    const getFormat = () => selectedVariant?.options?.find((option) => option === '50 g' || option === '15 g') || '';
    const scentKeys = { 'Monoï vanillé': 'monoi', 'Fleur de coton': 'cotton', 'Musc poudré': 'musk', 'Agrumes et sauge': 'citrus', 'Vanille épicée': 'spiced', 'Sans parfum': 'unscented' };
    const getScent = () => selectedVariant?.options?.find((option) => option !== '50 g' && option !== '15 g') || '';

    const updateSummary = () => {
      if (!selectedVariant) return;
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const pack = packRules[getFormat()]?.[quantity] || null;
      const fmt = (value) => `${Number(value).toLocaleString('fr-FR')} ${currency}`;
      const unit = selectedVariant.price / 100;
      const before = unit * quantity;
      const after = pack ? pack.price : before;
      const discount = pack ? Math.max(0, before - pack.price) : 0;
      const giftValue = pack ? (pack.giftValue || 0) : 0;

      if (beforeRow && beforeEl) { beforeRow.hidden = discount <= 0; beforeEl.textContent = fmt(before); }
      if (savingsRow && savingsEl) { savingsRow.hidden = discount <= 0; savingsEl.textContent = `− ${fmt(discount)}`; }
      if (giftRow && giftEl) { giftRow.hidden = giftValue <= 0; giftEl.textContent = fmt(giftValue); }
      if (priceLabel && summaryEl) priceLabel.textContent = discount > 0 ? (summaryEl.dataset.labelAfter || '') : (summaryEl.dataset.labelPrice || '');
      if (price) price.textContent = fmt(after);
      const welcome = window.AnyaWelcome.calculate(after);
      const welcomeRow = product.querySelector('[data-welcome-row]');
      if (welcomeRow) welcomeRow.hidden = welcome.discount <= 0;
      const welcomeAmount = product.querySelector('[data-welcome-amount]');
      if (welcomeAmount) welcomeAmount.textContent = '− ' + fmt(welcome.discount);
      if (stickyPrice) stickyPrice.textContent = fmt(welcome.net);
      if (shippingEl) shippingEl.textContent = shippingRate ? fmt(shippingRate.price) : (T.shipping_pending || 'Choisissez une ville');
      if (totalEl) totalEl.textContent = shippingRate ? fmt(welcome.net + shippingRate.price) : (T.shipping_pending || 'Choisissez une ville');
      if (scentDesc) scentDesc.textContent = (T.scent_desc && T.scent_desc[scentKeys[getScent()]]) || '';
    };

    const updatePackRecommendation = () => {
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const format = getFormat();
      recommendedPack = packRules[format]?.[quantity] || null;

      if (!packNotice) return;
      if (recommendedPack) {
        const standardTotal = (selectedVariant.price / 100) * quantity;
        packNotice.hidden = false;
        const nm = packName(recommendedPack);
        let bonusTxt = '';
        if (recommendedPack.bonus) {
          const b = (T.packs && T.packs.signature_bonus) || recommendedPack.bonus;
          bonusTxt = ` ${T.and_receive || 'et recevez'} ${b}`;
        }
        packKicker.textContent = T.pack_unlocked || 'Réduction automatiquement débloquée';
        packTitle.textContent = `${nm} — ${recommendedPack.price} ${currency}`;
        packCopy.textContent = `${T.at_instead || 'Au lieu de'} ${standardTotal.toLocaleString('fr-FR')} ${currency}, ${T.you_save || 'vous économisez'} ${recommendedPack.saving} ${currency}${bonusTxt}. ${T.choose_each || 'Choisissez maintenant chaque parfum séparément.'}`;
        composePack.firstChild.textContent = `${T.compose_prefix || 'Composer'} ${nm} `;
        whatsapp.textContent = `${T.compose_prefix || 'Composer'} ${nm}`;
        if (stickyWhatsapp) stickyWhatsapp.textContent = T.compose_pack || 'Composer le pack';
        return;
      }

      packNotice.hidden = quantity <= 1;
      if (quantity > 1) {
        packKicker.textContent = T.tip || 'Astuce économie';
        packTitle.textContent = format === '15 g' ? (T.tip_title_15 || 'Les packs minis commencent à 3 unités') : (T.tip_title_50 || 'Les offres grands formats existent par 2, 3 ou 4');
        packCopy.textContent = format === '15 g' ? (T.tip_copy_15 || 'Choisissez 3 ou 6 minis pour profiter d’un tarif pack et sélectionner chaque parfum séparément.') : (T.tip_copy_50 || 'Ajustez la quantité à 2, 3 ou 4 pour débloquer automatiquement le meilleur tarif correspondant.');
        composePack.firstChild.textContent = `${T.see_offers || 'Voir toutes les offres'} `;
      }
      whatsapp.textContent = product.dataset.i18nWhatsapp || 'Commander sur WhatsApp';
      if (stickyWhatsapp) stickyWhatsapp.textContent = product.dataset.i18nSticky || 'Commander';
    };

    const openPackComposer = () => {
      window.dispatchEvent(new CustomEvent('anya:select-pack', {
        detail: {
          offerId: recommendedPack?.offerId || null,
          scent: selectedVariant?.options?.find((option) => option !== '50 g' && option !== '15 g') || '',
          city: String(cityInput?.value || '').trim(),
          promo: String(promoInput?.value || getStoredPromo()).trim(),
        },
      }));
      (document.querySelector('#packs .anya-composer') || document.querySelector('#packs'))
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showSlide(i)));
    product.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    product.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    showSlide(activeIndex);
    if (!variantInput) return;

    window.AnyaShippingRates?.attach(cityInput, (match) => {
      shippingRate = match;
      if (match) {
        cityInput.value = match.city;
        cityInput.removeAttribute('aria-invalid');
        status.textContent = '';
      }
      updateSummary();
    }, currency, {
      rate: T.shipping_rate_label,
      delay: T.shipping_delay_label,
      hint: T.city_search_hint,
      empty: T.city_no_results,
    });

    const updateVariant = () => {
      const options = selectors.map((selector) => selector.value);
      selectedVariant = variants.find((variant) => variant.options.length === options.length && variant.options.every((option, i) => option === options[i]));
      if (!selectedVariant) {
        status.textContent = T.unavailable || 'Cette combinaison n’est pas disponible.';
        whatsapp.disabled = true;
        return;
      }
      status.textContent = '';
      whatsapp.disabled = false;
      variantInput.value = selectedVariant.id;
      updateSummary();
      if (stickyOptions) stickyOptions.textContent = selectors.map((selector) => selector.selectedOptions[0]?.textContent || selector.value).join(' · ');
      if (selectedVariant.featured_media) {
        const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(selectedVariant.featured_media.id));
        if (mediaIndex >= 0) showSlide(mediaIndex);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url);
      updatePackRecommendation();
    };

    selectors.forEach((selector) => selector.addEventListener('change', updateVariant));
    quantityInput?.addEventListener('input', () => { updateSummary(); updatePackRecommendation(); });
    quantityInput?.addEventListener('change', () => { updateSummary(); updatePackRecommendation(); });
    if (promoInput) {
      promoInput.value = promoInput.value || getStoredPromo();
      if (promoInput.value) promoInput.closest('details').open = true;
      promoInput.addEventListener('input', () => storePromo(promoInput.value.trim()));
    }
    window.addEventListener('anya:welcome-change', updateSummary);
    composePack?.addEventListener('click', openPackComposer);
    stickyWhatsapp?.addEventListener('click', () => whatsapp?.click());
    whatsapp?.addEventListener('click', () => {
      if (recommendedPack) {
        openPackComposer();
        return;
      }
      const phone = (product.dataset.whatsappNumber || '').replace(/\D/g, '');
      if (!phone || !selectedVariant) {
        status.textContent = T.wa_unavailable || 'La commande WhatsApp n’est pas disponible pour le moment.';
        return;
      }
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const city = String(cityInput?.value || '').trim();
      const delivery = window.AnyaShippingRates?.lookup(city);
      if (!delivery) {
        cityInput?.setAttribute('aria-invalid', 'true');
        status.textContent = T.city_required || 'Choisissez une ville proposée dans la liste pour calculer la livraison.';
        cityInput?.focus();
        return;
      }
      const productTotal = (selectedVariant.price / 100) * quantity;
      const welcome = window.AnyaWelcome.calculate(productTotal);
      const options = selectors.map((selector) => `${(selector.previousElementSibling.textContent || '').trim()} : ${(selector.selectedOptions[0]?.textContent || selector.value || '').trim()}`);
      const title = product.querySelector('h1')?.textContent.trim() || 'Déodorant crème naturel ANYA.';
      const promo = String(promoInput?.value || getStoredPromo()).trim();
      const message = [W.greeting,'',W.intent,`${W.product} : ${title}`,...options,`${W.quantity} : ${quantity}`,`${W.city} : ${delivery.city}`,'',`${W.products} : ${productTotal.toLocaleString('fr-FR')} ${currency}`,...window.AnyaWelcome.lines(productTotal, currency),`${W.shipping} : ${delivery.price.toLocaleString('fr-FR')} ${currency}`,`${window.AnyaWelcome.totalLabel} : ${(Math.round((welcome.net + delivery.price) * 100) / 100).toLocaleString('fr-FR')} ${currency}`,...(promo ? [`${T.promo_message_label || W.promo || 'Code promo / parrainage'} : ${promo}`,T.promo_message_note || 'À vérifier et appliquer par un agent ANYA. avant la confirmation.'] : []),'',W.confirm].join('\n');
      status.textContent = '';
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');

    });

    updateVariant();
  });
})();
